module.exports = __webpack_public_path__ + "media/assets/icons/nav_other-3e21c09c4dd23ba5ae4b15bd487efc2c.svg";